import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Save } from "lucide-react";

const TABS = [
  ["homepage", "Ana Sayfa"], ["instagram", "Instagram"], ["seo", "SEO"],
  ["head", "Head HTML"], ["social", "Sosyal Medya"], ["legal", "Yasal Sayfalar"],
  ["google", "Google Indexleme"], ["security", "Güvenlik"],
];

export default function Settings() {
  const [s, setS] = useState(null);
  const [tab, setTab] = useState("homepage");
  const [creds, setCreds] = useState({ current_password: "", new_email: "", new_password: "" });

  useEffect(() => { api.get("/admin/settings").then((r) => setS(r.data)).catch(() => {}); }, []);
  if (!s) return <div className="text-gray-400">Yükleniyor...</div>;

  const save = async (fields) => {
    try { await api.put("/admin/settings", fields); toast.success("Kaydedildi"); }
    catch { toast.error("Hata"); }
  };
  const upd = (k, v) => setS({ ...s, [k]: v });
  const updSeo = (k, v) => setS({ ...s, seo: { ...s.seo, [k]: v } });
  const updSocial = (k, v) => setS({ ...s, social_links: { ...s.social_links, [k]: v } });

  const Input = ({ label, value, onChange, ...p }) => (
    <div><label className="text-sm text-gray-300 font-medium">{label}</label>
      <input value={value || ""} onChange={onChange} {...p} className="w-full bg-[#171922] border border-white/10 rounded-xl px-4 py-2.5 text-white text-sm mt-1.5" /></div>
  );
  const Area = ({ label, value, onChange, rows = 4, mono, ...p }) => (
    <div><label className="text-sm text-gray-300 font-medium">{label}</label>
      <textarea value={value || ""} onChange={onChange} rows={rows} {...p} className={`w-full bg-[#171922] border border-white/10 rounded-xl px-4 py-2.5 text-white text-sm mt-1.5 ${mono ? "font-mono" : ""}`} /></div>
  );
  const SaveBtn = ({ onClick }) => <button onClick={onClick} className="btn-gradient px-6 py-2.5 rounded-xl font-bold flex items-center gap-2 mt-2" data-testid="settings-save-btn"><Save size={16} /> Kaydet</button>;

  return (
    <div>
      <h1 className="text-2xl font-extrabold text-white mb-6">Site & SEO Ayarları</h1>
      <div className="flex gap-2 overflow-x-auto no-scrollbar mb-6">
        {TABS.map(([k, l]) => (
          <button key={k} onClick={() => setTab(k)} className={`px-4 py-2 rounded-xl text-sm font-medium whitespace-nowrap ${tab === k ? "bg-white text-[#1f222d]" : "bg-white/5 text-gray-300 hover:bg-white/10"}`} data-testid={`settings-tab-${k}`}>{l}</button>
        ))}
      </div>

      {tab === "homepage" && (
        <div className="card-surface p-6 space-y-4 max-w-2xl">
          <Input label="Site Başlığı" value={s.site_title} onChange={(e) => upd("site_title", e.target.value)} />
          <Area label="Hero Başlığı" value={s.hero_title} onChange={(e) => upd("hero_title", e.target.value)} rows={2} />
          <Area label="Hero Açıklaması" value={s.hero_subtitle} onChange={(e) => upd("hero_subtitle", e.target.value)} rows={3} />
          <Input label="CTA Buton Metni" value={s.hero_cta_text} onChange={(e) => upd("hero_cta_text", e.target.value)} />
          <Input label="Logo URL" value={s.logo_url} onChange={(e) => upd("logo_url", e.target.value)} />
          <Input label="Favicon URL" value={s.favicon_url} onChange={(e) => upd("favicon_url", e.target.value)} />
          <Input label="Destek/WhatsApp URL" value={s.support_url} onChange={(e) => upd("support_url", e.target.value)} />
          <Area label="Footer Açıklaması" value={s.footer_description} onChange={(e) => upd("footer_description", e.target.value)} rows={2} />
          <div>
            <label className="text-sm text-gray-300 font-medium">İstatistikler</label>
            {(s.stats || []).map((st, i) => (
              <div key={i} className="flex gap-2 mt-2">
                <input value={st.value} onChange={(e) => { const arr = [...s.stats]; arr[i] = { ...arr[i], value: e.target.value }; upd("stats", arr); }} placeholder="Değer" className="flex-1 bg-[#171922] border border-white/10 rounded-xl px-3 py-2 text-white text-sm" />
                <input value={st.label} onChange={(e) => { const arr = [...s.stats]; arr[i] = { ...arr[i], label: e.target.value }; upd("stats", arr); }} placeholder="Etiket" className="flex-1 bg-[#171922] border border-white/10 rounded-xl px-3 py-2 text-white text-sm" />
              </div>
            ))}
          </div>
          <SaveBtn onClick={() => save({ site_title: s.site_title, hero_title: s.hero_title, hero_subtitle: s.hero_subtitle, hero_cta_text: s.hero_cta_text, logo_url: s.logo_url, favicon_url: s.favicon_url, support_url: s.support_url, footer_description: s.footer_description, stats: s.stats })} />
        </div>
      )}

      {tab === "instagram" && (
        <div className="card-surface p-6 space-y-4 max-w-2xl">
          <Input label="Görünen Ad" value={s.instagram_display_name} onChange={(e) => upd("instagram_display_name", e.target.value)} />
          <Input label="Kullanıcı Adı (@ olmadan)" value={s.instagram_username} onChange={(e) => upd("instagram_username", e.target.value)} />
          <Input label="Instagram Profil URL" value={s.instagram_url} onChange={(e) => upd("instagram_url", e.target.value)} />
          <Input label="Profil Görseli URL" value={s.ig_profile_image} onChange={(e) => upd("ig_profile_image", e.target.value)} />
          <div className="grid grid-cols-3 gap-3">
            <Input label="Gönderi" type="number" value={s.ig_posts} onChange={(e) => upd("ig_posts", Number(e.target.value))} />
            <Input label="Takipçi" type="number" value={s.ig_followers} onChange={(e) => upd("ig_followers", Number(e.target.value))} />
            <Input label="Takip" type="number" value={s.ig_following} onChange={(e) => upd("ig_following", Number(e.target.value))} />
          </div>
          <SaveBtn onClick={() => save({ instagram_display_name: s.instagram_display_name, instagram_username: s.instagram_username, instagram_url: s.instagram_url, ig_profile_image: s.ig_profile_image, ig_posts: s.ig_posts, ig_followers: s.ig_followers, ig_following: s.ig_following })} />
        </div>
      )}

      {tab === "seo" && (
        <div className="card-surface p-6 space-y-4 max-w-2xl">
          <Input label="SEO Title" value={s.seo?.title} onChange={(e) => updSeo("title", e.target.value)} />
          <Area label="Meta Description" value={s.seo?.description} onChange={(e) => updSeo("description", e.target.value)} rows={2} />
          <Input label="Keywords" value={s.seo?.keywords} onChange={(e) => updSeo("keywords", e.target.value)} />
          <Input label="Canonical" value={s.seo?.canonical} onChange={(e) => updSeo("canonical", e.target.value)} />
          <Input label="Robots" value={s.seo?.robots} onChange={(e) => updSeo("robots", e.target.value)} />
          <Input label="OG Image" value={s.seo?.og_image} onChange={(e) => updSeo("og_image", e.target.value)} />
          <SaveBtn onClick={() => save({ seo: s.seo })} />
        </div>
      )}

      {tab === "head" && (
        <div className="card-surface p-6 space-y-4 max-w-3xl">
          <p className="text-sm text-yellow-300 bg-yellow-500/10 rounded-xl p-4">Google Analytics, GTM, Meta Pixel, verification, özel meta/script kodlarını buraya ekleyin. Sadece admin tarafından yönetilir.</p>
          <Area label="Head HTML (</head> öncesi)" value={s.head_html} onChange={(e) => upd("head_html", e.target.value)} rows={8} mono placeholder="<!-- Google Analytics, meta, script -->" />
          <Area label="Footer HTML" value={s.footer_html} onChange={(e) => upd("footer_html", e.target.value)} rows={4} mono />
          <SaveBtn onClick={() => save({ head_html: s.head_html, body_start_html: s.body_start_html, footer_html: s.footer_html })} />
        </div>
      )}

      {tab === "social" && (
        <div className="card-surface p-6 space-y-4 max-w-2xl">
          {["instagram", "tiktok", "youtube", "twitter", "telegram", "facebook"].map((k) => (
            <Input key={k} label={k.charAt(0).toUpperCase() + k.slice(1)} value={s.social_links?.[k]} onChange={(e) => updSocial(k, e.target.value)} />
          ))}
          <SaveBtn onClick={() => save({ social_links: s.social_links })} />
        </div>
      )}

      {tab === "legal" && (
        <div className="card-surface p-6 space-y-6 max-w-3xl">
          {Object.entries(s.legal || {}).map(([slug, page]) => (
            <div key={slug} className="border-b border-white/10 pb-4">
              <Input label={`${page.title} (/${slug})`} value={page.title} onChange={(e) => upd("legal", { ...s.legal, [slug]: { ...page, title: e.target.value } })} />
              <Area label="İçerik (HTML)" value={page.content} onChange={(e) => upd("legal", { ...s.legal, [slug]: { ...page, content: e.target.value } })} rows={4} mono />
            </div>
          ))}
          <SaveBtn onClick={() => save({ legal: s.legal })} />
        </div>
      )}

      {tab === "google" && (
        <div className="card-surface p-6 space-y-4 max-w-2xl">
          <Input label="Google Site Verification" value={s.google_verification} onChange={(e) => upd("google_verification", e.target.value)} />
          <Input label="Search Console Property" value={s.gsc_property} onChange={(e) => upd("gsc_property", e.target.value)} />
          <Area label="Service Account JSON Credential" value={s.indexing_json} onChange={(e) => upd("indexing_json", e.target.value)} rows={5} mono placeholder="Daha sonra eklenebilir" />
          <div className="text-sm text-gray-400 bg-white/5 rounded-xl p-4">Sitemap: <code className="text-[#d8b4fe]">{process.env.REACT_APP_BACKEND_URL}/api/sitemap.xml</code><br />Robots: <code className="text-[#d8b4fe]">{process.env.REACT_APP_BACKEND_URL}/api/robots.txt</code></div>
          <SaveBtn onClick={() => save({ google_verification: s.google_verification, gsc_property: s.gsc_property, indexing_json: s.indexing_json })} />
        </div>
      )}

      {tab === "security" && (
        <div className="card-surface p-6 space-y-4 max-w-md">
          <h3 className="font-bold text-white">Yönetici Bilgilerini Değiştir</h3>
          <Input label="Mevcut Şifre" type="password" value={creds.current_password} onChange={(e) => setCreds({ ...creds, current_password: e.target.value })} />
          <Input label="Yeni E-posta (opsiyonel)" value={creds.new_email} onChange={(e) => setCreds({ ...creds, new_email: e.target.value })} />
          <Input label="Yeni Şifre (opsiyonel)" type="password" value={creds.new_password} onChange={(e) => setCreds({ ...creds, new_password: e.target.value })} />
          <button onClick={async () => {
            try {
              await api.post("/auth/change-credentials", { current_password: creds.current_password, new_email: creds.new_email || null, new_password: creds.new_password || null });
              toast.success("Güncellendi. Tekrar giriş yapmanız gerekebilir."); setCreds({ current_password: "", new_email: "", new_password: "" });
            } catch (e) { toast.error(e.response?.data?.detail || "Hata"); }
          }} className="btn-gradient px-6 py-2.5 rounded-xl font-bold" data-testid="change-creds-btn">Güncelle</button>
        </div>
      )}
    </div>
  );
}
